import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const trackingConversionPlatformSubmissionEntity: Entity = {
  model: model,
  repository: repository,
}

export default trackingConversionPlatformSubmissionEntity
